import React from "react";

const Banner_about = () => {
  return (
    <div className="banner_about">
      <img src="/banner-a-propos.jpg" alt="background image" />
    </div>
  );
};

export default Banner_about;
